import React from "react";
import { withTranslation } from "react-i18next";
import { Chart } from "react-google-charts";

import classNames from "classnames";
import "./index.scss";

const ChartControl = ({ t, value }) => {
  const isEmpty = !value || (!value.data || !value.data?.length || value.data?.length === 1);

  return (
    <div className={classNames("chartControl")}>
      {!isEmpty && (<Chart {...value} />)}
      {isEmpty && (
        <div className={classNames("nodata")}>
          {value.emptyLabel || t("reports.NO_DATA")}
        </div>
      )}
    </div>
  );
};

export default withTranslation()(ChartControl);
